import React from 'react';
import '../styles/general.css';

const Header = () => (
  <header>
    <h1>Women Protection Analytics</h1>
    <h2>"Your Safety, Your Support, Your Strength—All in One Place."</h2>
  </header>
);

export default Header;
